import shensha from '../base/shensha'
import { FORMAT } from './format';
import { UTILS } from '../../utils';

/**
 * 神煞算法
 */
var SHEN_SHA = {

    /**
     * 
     * 获取当前显示柱的神煞数据
     * @param {原命盘的四柱} fateSiZhu 
     * @param {要求神煞值的所有干支柱} allZhu 
     */
    getAllListShenSha(fateSiZhu, allZhu) {
        var rigan = fateSiZhu[2].charAt(0), resultArr = [];
        // console.log('getAllListShenSha-------', fateSiZhu, allZhu, rigan);
        allZhu.forEach((text, index) => {
            console.log('getAllListShenSha---index::::::text', index, text)
            if(text == ''){ 
                resultArr.push({});
                return; 
            }
            // 1 十二长生
            var changshengArr = [
                this.getChangShengByGan(rigan, text.charAt(1)),
                '坐' + this.getChangShengByGan(text.charAt(0), text.charAt(1))
            ];
            // 2 神煞
            var shenshaArr = this.getAllShenShaByFateSiZhu(fateSiZhu, index, text);
            resultArr.push({
                changsheng: changshengArr,
                shensha: shenshaArr
            });
        });

        console.log('getAllListShenSha-------', resultArr)
        return resultArr;
    },
    
    /**
     * 获取天干的十二长生
     * @param {天干/日干} gan 
     * @param {地支} dizhi 
     */
    getChangShengByGan(gan, dizhi) {
        var changsheng = shensha.changsheng.text;
        var ganT = shensha.changsheng.gan;

        var ganI = FORMAT.getTianGanIndexByText(gan),
            ganText = ganT[ganI],
            dizhiI = ganText.indexOf(dizhi),
            changshengT = changsheng[dizhiI];
            console.log('getChangShengByTianGan----', gan, dizhi, ganText, dizhiI, changshengT)
        return changshengT;
    },

    /**
     * 根据干支获取神煞
     * @param {原命盘四柱} fateSiZhu 
     * @param {当前干支的index} index 
     * @param {当前要求神煞的干支} ganzhi 
     */
    getAllShenShaByFateSiZhu(fateSiZhu, index, ganzhi) {
        var nianZhu = fateSiZhu[0], yueZhu = fateSiZhu[1], riZhu = fateSiZhu[2], shiZhu = fateSiZhu[3];
        // console.log('getAllShenShaByFateSiZhu-----', nianZhu, yueZhu, riZhu, shiZhu, ganzhi)

        // 轮询获取各种神煞
        var resultArr = [], ss1 = [], ss2 = [], ss3 = [], ss4 = [], ss5 = [], ss6 = [], ss7 = [], ss8 = [], ss9 = [], ss10 = [];
        
        // 根据年日干获取的神煞:比对四柱
        ss1 = this.getShenShaByNianRiGan(nianZhu.charAt(0), riZhu.charAt(0), ganzhi);
        resultArr = resultArr.concat(ss1);
        
        // 根据月支获取的神煞:不用比对月支
        if(index != 1) {
            ss2 = this.getShenShaByYueZhi(yueZhu.charAt(1), ganzhi);
            resultArr = resultArr.concat(ss2);
        }
        // 根据日干获取的神煞:比对四柱
        ss3 = this.getShenShaByRiGan(riZhu.charAt(0), ganzhi);
        resultArr = resultArr.concat(ss3);

        // 根据年日支获取的神煞:只查其余支
        if(index != 0){
            ss4 = this.getShenShaByNianRiZhi(nianZhu.charAt(1), ganzhi);
            resultArr = resultArr.concat(ss4);
        }
        if (index != 2){
            ss5 = this.getShenShaByNianRiZhi(riZhu.charAt(1), ganzhi);
            resultArr = resultArr.concat(ss5);
        }

        // 根据年支获取的神煞:
        if(index != 0) {
            ss6 = this.getShenShaByNianZhi(nianZhu.charAt(1), ganzhi);
            resultArr = resultArr.concat(ss6);
        }

        // 根据日支获取的神煞:不用比对日支
        if(index != 2){
            ss7 = this.getShenShaByRiZhi(riZhu.charAt(1), ganzhi);
            resultArr = resultArr.concat(ss7);
        }

        // 根据日柱组合获取的神煞:Todo 只考虑日柱一柱吗？
        if(index == 2){
            ss8 = this.getShenShaByRiZhu(riZhu);
            resultArr = resultArr.concat(ss8);
        }

        // 根据日干获取对比时柱的神煞:
        if(index == 3) {
            ss9 = this.getShenShaByRiGanOther(riZhu.charAt(0), shiZhu.charAt(1));
            resultArr = resultArr.concat(ss9);

            ss10 = this.getShenShaByShiZhu(shiZhu);
            resultArr = resultArr.concat(ss10);
        }
        // console.log('getAllShenShaByFateSiZhu-----', index, resultArr)
        return resultArr;
    },

    /**
     * 根据年日干获取神煞
     * @param {年干} niangan 
     * @param {日干} rigan 
     * @param {干支} ganzhi 
     */
    getShenShaByNianRiGan(niangan, rigan, ganzhi) {
        var nianriganT = shensha.nianrigan.text,
            nianganI = nianriganT.indexOf(niangan),
            riganI = nianriganT.indexOf(rigan),
            zhi = ganzhi.charAt(1), resultArr = [];
        // console.log('getShenShaByNianRiGan-----', niangan, rigan, nianganI, riganI, zhi);

        var childData = shensha.nianrigan.classify;
        for(var keys in childData) {
            var duizhao = childData[keys].duizhao;
            if(keys == 'tianyiguiren') {
                // 天乙贵人 对照数据为数组
                if(duizhao[nianganI].indexOf(zhi) != -1 || duizhao[riganI].indexOf(zhi) != -1) {
                    resultArr.push(childData[keys].text);
                }
            }else if(keys == 'guoyinguiren') {
                // 国印贵人 对照数据为字符串
                if(duizhao.charAt(nianganI) == zhi || duizhao.charAt(riganI) == zhi) {
                    resultArr.push(childData[keys].text);
                }
            }
        }
        // console.log('getShenShaByNianRiGan-----resultArr', resultArr);
        return resultArr;
    },

    /**
     * 根据月支获取神煞
     * @param {月支} yuezhi 
     * @param {干支} ganzhi 
     */
    getShenShaByYueZhi(yuezhi, ganzhi){
        var yuezhiT = shensha.yuezhi.text,
            yuezhiI = yuezhiT.indexOf(yuezhi),
            gan = ganzhi.charAt(0), zhi = ganzhi.charAt(1), resultArr = [];
        // console.log('getShenShaByYueZhi-----', yuezhi, yuezhiI, gan, zhi);

        var childData = shensha.yuezhi.classify;
        for(var keys in childData) {
            var duizhao = childData[keys].duizhao;
            if(keys == 'tiandeguiren' || keys == 'yuedeguiren'){
                // 天德贵人 和 月德贵人 参照 年日时干
                if(duizhao.charAt(yuezhiI) == gan){
                    resultArr.push(childData[keys].text);
                }
            }else if(keys == 'tianyixing') {
                // 天医星 参照 日支
                if(duizhao.charAt(yuezhiI) == zhi){
                    resultArr.push(childData[keys].text)
                }
            }
        }
        console.log('getShenShaByYueZhi----resultArr------', yuezhi, gan, zhi, resultArr)
        return resultArr;
    },

    /**
     * 根据日干获取神煞
     * @param {日干} rigan 
     * @param {干支} ganzhi 
     */
    getShenShaByRiGan(rigan, ganzhi){
        var riganT = shensha.rigan.text,
            riganI = riganT.indexOf(rigan),
            zhi = ganzhi.charAt(1), resultArr = [];

        var childData = shensha.rigan.classify;
        for(var keys in childData) {
            var duizhao = childData[keys].duizhao;
            if(keys == 'tianyiguiren' || keys == 'taijiguiren') {
                // 天乙贵人、太极贵人 对照数据为数组
                if(duizhao[riganI].indexOf(zhi) != -1){
                    resultArr.push(childData[keys].text);
                }
            }else {
                // 其他日干对照的神煞 对照数据均为字符串
                if(duizhao.charAt(riganI) == zhi) {
                    resultArr.push(childData[keys].text);
                }
            }
        }
        console.log('getShenShaByRiGan----resultArr------', rigan, zhi, resultArr);
        return resultArr;
    },

    /**
     * 根据年日支获取神煞:只查其余支
     * @param {年支/日支} nianrizhi 
     * @param {干支} ganzhi 
     */
    getShenShaByNianRiZhi(nianrizhi, ganzhi) {
        var nianrizhiT = shensha.nianrizhi.text, 
            nianrizhiI = UTILS.getTextIndexInStringArray(nianrizhiT, nianrizhi),
            zhi = ganzhi.charAt(1), resultArr = [];
        
        var nianrizhiData = shensha.nianrizhi.classify;
        for(var key in nianrizhiData){
            var duizhao = nianrizhiData[key].duizhao;
            if(duizhao.charAt(nianrizhiI) == zhi){
                resultArr.push(nianrizhiData[key].text)
            }
        }
        console.log('getShenShaByNianRiZhi----resultArr------', nianrizhi, zhi, resultArr);
        return resultArr;
    },

    /**
     * 根据年支获取神煞
     * @param {年支} nianzhi 
     * @param {干支} ganzhi 
     */
    getShenShaByNianZhi(nianzhi, ganzhi) {
        var nianzhiT = shensha.nianzhi.text,
            nianzhiI = nianzhiT.indexOf(nianzhi),
            resultArr = [], zhi = ganzhi.charAt(1);

        var childData = shensha.nianzhi.classify;
        for(var key in childData) {
            var duizhao = childData[key].duizhao;
            if(duizhao.charAt(nianzhiI) == zhi){
                resultArr.push(childData[key].text);
            }
        }
        console.log('getShenShaByNianZhi-----', nianzhi, zhi, resultArr)
        return resultArr;
    },

    /**
     * 根据日支获取神煞
     * @param {日支} rizhi 
     * @param {干支} ganzhi 
     */
    getShenShaByRiZhi(rizhi, ganzhi){
        var resultArr = [], zhi = ganzhi.charAt(1);
        var childData = shensha.rizhi.classify;
        for(var key in childData){
            var duizhaoT = childData[key].rizhi,
                rizhiI = duizhaoT.indexOf(rizhi),
                duizhao = childData[key].duizhao;
            if(duizhao.charAt(rizhiI) == zhi){
                resultArr.push(childData[key].text);
            }
        }
        console.log('getShenShaByRiZhi------', rizhi, zhi, resultArr)
        return resultArr;
    },

    /**
     * 根据日干（其他特殊:截路空亡）获取神煞
     * @param {日干} rigan 
     * @param {时支} shizhi
     */
    getShenShaByRiGanOther(rigan, shizhi) {
        var riganData = shensha.riganother.classify, resultArr = [];
        for(var key in riganData){
            var riganI = UTILS.getTextIndexInStringArray(riganData[key].rigan, rigan);
            var duizhao = riganData[key].duizhao;
            if(duizhao[riganI].indexOf(shizhi) != -1) {
                resultArr.push(riganData[key].text);
            }
        }
        console.log('getShenShaByRiGanOther-----', rigan, shizhi, resultArr);
        return resultArr;
    },

    /**
     * 根据日柱的组合获取神煞
     * @param {日柱} rizhu 
     */
    getShenShaByRiZhu(rizhu) {
        var rizhuData = shensha.rizhu.classify, resultArr = [];
        for(var key in rizhuData){
            var duizhao = rizhuData[key].duizhao;
            if(duizhao.indexOf(rizhu) != -1){
                resultArr.push(rizhuData[key].text);
            }
        }
        console.log('getShenShaByRiZhu----', rizhu, resultArr);
        return resultArr;
    },

    /**
     * 根据时柱的组合获取神煞
     * @param {时柱} shizhu 
     */
    getShenShaByShiZhu(shizhu) {
        var shizhuData = shensha.shizhu.classify, resultArr = [];
        for(var key in shizhuData){
            var duizhao = shizhuData[key].duizhao;
            if(duizhao.indexOf(shizhu) != -1){
                resultArr.push(shizhuData[key].text);
            }
        }
        console.log('getShenShaByShiZhu----', shizhu, resultArr);
        return resultArr;
    }

}

export {
    SHEN_SHA
}